export default "__VITE_ASSET__e73e0055__"